import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[500px] md:h-[620px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=A%20warm%20artistic%20digital%20illustration%20of%20colorful%20Korean%20webtoon%20comic%20panels%20scattered%20across%20a%20soft%20cream%20background%2C%20stylized%20manga%20screentones%20and%20speech%20bubbles%2C%20modern%20minimalist%20reading%20platform%20aesthetic%2C%20warm%20coral%20and%20amber%20accents%2C%20clean%20composition%2C%20no%20text&width=1600&height=700&seq=hero-bg-kr-comics&orientation=landscape"
        alt="韩漫大全 - 好看韩国漫画在线阅读"
        title="韩漫大全 漫画网址 韩漫漫画网站"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>

      <div className="relative z-10 h-full flex flex-col items-center justify-center text-center px-4">
        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl text-white mb-4 max-w-3xl leading-tight">
          韩漫大全 - 好看韩国漫画<span className="text-primary-300">免费在线阅读</span>
        </h1>
        <p className="text-white/80 text-base md:text-lg max-w-2xl mb-8 leading-relaxed">
          韩漫漫画网站通过此漫画网址提供韩漫大全与好看韩国漫画的免费在线阅读，资源稳定更新及时。每日更新热门韩漫，畅享极致阅读体验。
        </p>
        <div className="flex flex-col sm:flex-row gap-4">
          <Link
            to="/category/hot"
            className="px-8 py-3 rounded-full bg-primary-500 text-white font-semibold text-sm hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            热门连载
          </Link>
          <Link
            to="/category/new"
            className="px-8 py-3 rounded-full bg-white/15 backdrop-blur-sm text-white font-semibold text-sm hover:bg-white/25 transition-colors border border-white/30 cursor-pointer whitespace-nowrap"
          >
            最新上架
          </Link>
        </div>
      </div>

      <div className="absolute bottom-6 left-1/2 -translate-x-1/2">
        <div className="w-6 h-10 rounded-full border-2 border-white/40 flex items-start justify-center p-1.5">
          <div className="w-1 h-2.5 bg-white/60 rounded-full animate-bounce"></div>
        </div>
      </div>
    </section>
  );
}